import { render, staticRenderFns } from "./VdoSetInfo.vue?vue&type=template&id=1086d66c&scoped=true&"
import script from "./VdoSetInfo.vue?vue&type=script&lang=js&"
export * from "./VdoSetInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086d66c",
  null
  
)

export default component.exports